import { Button, Card, Dropdown, FormControl, Modal, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import Avatar from '../../jsx/components/fields/avatar';
import profileAv from '../../icons/photos/profileAvatar.png';
import filter from '../../icons/photos/filter.svg';
import InputField from '../../jsx/components/fields/inputField';
import SearchAddressInput from '../../jsx/components/fields/searchAddressInput';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import InternationalPhoneFormatFun from '../../ui/InternationalPhoneFormatFun';
import { emailValidation, firstNameValidation, noSpaceOnChange, numberValidation, phoneOnChange, phoneValidation } from '../../functions/validations'
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';

import { userById } from '../../service/api/user/userById'
import updateUserApi from '../../service/api/user/updateUserDetails';
// import { setUserDetails } from '../../feature/userDetails/userDetailsSlice'
import { setUserDetails } from '../../feature/userData/userData'
import { signout } from '../../feature/authSlice';
import deleteUser from '../../service/api/user/deleteUserById';
import { searchAddress } from '../../service/api/user/searchAddress';
import { addressByPlaceId } from '../../service/api/user/addressByPlaceID';


import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import WhiteGreenButton from '../../jsx/components/button/whiteGreenButton';
import ResponceForAPI from '../../component/backDrop/responcesForAPI';
import Select from "react-select";
import { btnBio, btnSubmit, btnUpdateProfile, btnUpdateProfileLoading } from '../../dataBaseFile/alert';
import { btnVerify, lblAddress, lblEmail, lblFirstName, lblLastName, lblPhoneNumber, txtMainInfo, txtMobileNumber, txtRole, txtSearchAddress, txtUserDetails } from '../../dataBaseFile/label';
import { validEmailText, validFirstName, validLastName, validMobileNumberText } from '../../dataBaseFile/error';
import { getRegistereedCompaniesApi } from '../../service/api/user/getRegisteredCompanies';
import JoinAsField from '../../jsx/components/fields/joinAsField';
import SelectStateCompanies from '../../jsx/components/fields/selectStateCompanies';
import WorkInfo from '../userProfile/workInfo';
import UploadDocuments from '../userProfile/uploadDocuments';
import { resendCode } from '../../service/api/user/resendActivationCode';
import { activateUser } from '../../service/api/user/activationCode';
import PhonenumberField from '../../jsx/components/fields/phoneFields';
import UpdateEmailPhoneInputField from '../../jsx/components/fields/updateEmailPhoneInputField';
import { apiGetRegisteredCompanies } from '../../service/api/companies/getRegisteredCompanies';
import EmailPhoneCombine from '../../jsx/components/fields/emailPhoneField';

const ParticularUserDetailsForAdminPage = ({ profileData }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { role, rolesUserCanAssign } = useSelector((state) => state.user);
    const [roleIHave, setRoleIhhave] = useState([])

    const { permissionArr, impersonateFlag } = useSelector((state) => state.user);
    const permissionArray = permissionArr[0] || []

    const [basicModalDeleteAccount, setBasicModalDeleteAccount] = useState(false);


    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [extraNote, setExtraNote] = useState('')
    const [userName, setUserName] = useState('')
    const [phonenumber, setPhonenumber] = useState('')
    const [photoToUpload, setPhotoToUpload] = useState(null)
    const [countryCode, setCountryCode] = useState('')
    const [email, setEmail] = useState('')
    const [isFirstNameError, setIsFirstNameError] = useState(false)
    const [isEmailError, setIsEmailError] = useState(false)
    const [loaderActive, setLoaderActive] = useState(true)
    const [isErrorButton, setIsErrorButton] = useState(false)
    const [isSuccessButton, setIsSuccessButton] = useState(false)
    const [avatarUrl, setAvatarUrl] = useState("")
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [avatarArr, setAvatarArr] = useState([])
    const [avatarId, setAvatarId] = useState()
    const [updateBtn, setUpdateBtn] = useState(true)
    const [openDialog, setOpenDialog] = useState(false);
    const [addressArr, setAddressArr] = useState([])
    const [searchText, setSearchText] = useState('')

    const [roleName, setRoleName] = useState('')
    const [companyName, setCompanyName] = useState("")
    const [addressLine1, setAddressLine1] = useState(" ");
    const [addressLine2, setAddressLine2] = useState(" ");
    const [cityName, setCityName] = useState('')
    const [stateName, setStateName] = useState('')
    const [countryName, setCountryName] = useState(' ')
    const [zipCode, setZipCode] = useState(' ')

    const [latVal, setLatVal] = useState(0)
    const [longVal, setLongVal] = useState(0)
    const [address, setAddress] = useState('')
    const [placeIdVal, setPlaceId] = useState('')

    const [countryCodeNew, setCountryCodeNew] = useState();

    const [phoneNumberFormat, setPhoneNumberFormat] = useState();
    const [responceMsg, setResponceMsg] = useState("");
    const [updateProfileLoading, setUpdateProfileLoading] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [handleToaster, setHandleToaster] = useState(false);

    const [apiResponce, setApiResponse] = useState(true);

    const [companiesList, setCompaniesList] = useState([])
    const [companyId, setCompanyId] = useState("")

    // Verify Email and Phone starts here -----------------------
    const [isEmailConfirmed, setIsEmailConfirmed] = useState(0);
    const [isPhoneConfirmed, setIsPhoneConfirmed] = useState(0);

    const [triggerForVerifyModal, setTriggerForVerifyModal] = useState(false);
    const [checkForEmailVerification, setCheckForEmailVerification] = useState(false);
    const [checkForPhoneVerification, setCheckForPhoneVerification] = useState(false);

    const [emailNew, setEmailNew] = useState('');
    const [phoneNumberNew, setPhoneNumberNew] = useState();
    const [countryCodeNewNew, setCountryCodeNewNew] = useState(1);

    const [isEmailErrorNew, setIsEmailErrorNew] = useState(false);
    const [errorEmailMsg, setErrorEmailMsg] = useState("");
    const [isPhoneErrorNew, setIsPhoneErrorNew] = useState(false);

    const [checkAfterVerificationCodeSend, setCheckAfterVerificationCodeSend] = useState(false);

    const [recievedCodeValue, setRecievedCodeValue] = useState("");
    const [isCodeError, setIsCodeError] = useState(false);

    const [resendCodeTimer, setResendCodeTimer] = useState(60);
    const [resendCodeCheck, setResendCodeCheck] = useState(false);

    const [verifyUserLoading, setVerifyUserLoading] = useState(false);

    const [isVerificationCodeSendDirectly, setIsVerificationCodeSendDirectly] = useState(false);

    const intervalId = useRef(null);

    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [columnName, setColumnName] = useState("created_date_dtm");
    const [searchValue, setSearchValue] = useState("");


    useEffect(() => {

        if (resendCodeCheck && resendCodeTimer > 0) {
            intervalId.current = setInterval(() => setResendCodeTimer(prev => prev - 1), 1000);
        } else if (!resendCodeCheck || resendCodeTimer === 0) {
            clearInterval(intervalId.current);
        }

        if (resendCodeTimer === 0) {
            setResendCodeCheck(false);
        }
        return () => clearInterval(intervalId.current);
    }, [resendCodeCheck, resendCodeTimer]);



    function handleClearVerifyEmailPhoneStates() {
        setEmailNew('');
        setPhoneNumberNew();
        setCountryCodeNewNew(1);
        setIsEmailErrorNew(false);
        setIsPhoneErrorNew(false);
        setCheckAfterVerificationCodeSend(false);
        setResendCodeCheck(false);
        setResendCodeTimer(60);
        setRecievedCodeValue("");
        setVerifyUserLoading(false);
        setIsCodeError(false);
        setIsVerificationCodeSendDirectly(false);

    }

    const handleEmailNew = (e) => {
        // debugger
        setIsEmailErrorNew(false);
        noSpaceOnChange(e.target.value) && setEmailNew(e.target.value);
    };

    function handleEmailBlurCheckNew() {
        if (!emailValidation(emailNew)) {
            setIsEmailErrorNew(true);
            if (emailNew === '') {
                setErrorEmailMsg("Please enter email")
            } else {
                setErrorEmailMsg(validEmailText)
            }
        }
    }

    const handlePhonenumberNew = (e) => {
        setIsPhoneErrorNew(false);
        phoneOnChange(e.target.value) && setPhoneNumberNew(e.target.value);
    };

    const handleCountryCodeNew = (e) => {
        setCountryCodeNewNew(e.target.value);
    };

    function handlePhonenumberBlurCheckNew() {
        if (!phoneValidation(phoneNumberNew) && phoneNumberNew == '' || phoneNumberNew.length !== 10) {
            setIsPhoneErrorNew(true);
        }
    }

    function handleVerify(e) {
        e?.preventDefault();
        setVerifyUserLoading(true);


        // setResendCodeCheck(true);
        // setResendCodeTimer(60);


        if (checkForEmailVerification) {
            if (!emailValidation(emailNew)) {
                setIsEmailErrorNew(true);

                if (emailNew === '') {
                    setErrorEmailMsg("Please enter email")
                    setVerifyUserLoading(false);
                } else {
                    setErrorEmailMsg(validEmailText)
                    setVerifyUserLoading(false);
                }
            } else {
                // console.log("email verification", emailNew)


                let formData = new FormData();
                formData.append("phone_code_id_int", 0);
                formData.append("phone_number_int", 0);
                formData.append("email_chr", emailNew);
                !isVerificationCodeSendDirectly && formData.append("user_id_ids", localStorage.getItem('user_id_for_admin'));

                // console.log("phone_code_id_int", 0)
                // console.log("phone_number_int", 0)
                // console.log("email_chr", emailNew)
                // console.log("user_id_ids", localStorage.getItem('user_id'))


                dispatch(
                    resendCode(
                        formData, (res) => {
                            setResponceMsg(res.data.message);
                            setToasterType("success")
                            setHandleToaster(true)

                            setVerifyUserLoading(false);
                            setCheckAfterVerificationCodeSend(true);
                            setResendCodeCheck(true);
                            setResendCodeTimer(60);

                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }, (err) => {
                            setResponceMsg(err.data.message);
                            setToasterType("error")
                            setHandleToaster(true)

                            setVerifyUserLoading(false);


                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    )
                )
            }

        }
        if (checkForPhoneVerification) {

            if (!phoneValidation(phoneNumberNew) && !isVerificationCodeSendDirectly) {

                setIsPhoneErrorNew(true);
                setVerifyUserLoading(false);

            } else {
                // console.log("phone verification", phoneNumberNew, "country code", countryCodeNewNew)

                let formData = new FormData();
                formData.append("phone_code_id_int", parseInt(countryCodeNewNew));
                formData.append("phone_number_int", parseInt(phoneNumberNew));
                formData.append("email_chr", "");
                !isVerificationCodeSendDirectly && formData.append("user_id_ids", localStorage.getItem('user_id_for_admin'));

                // console.log("phone_code_id_int", parseInt(countryCodeNewNew))
                // console.log("phone_number_int", parseInt(phoneNumberNew))
                // console.log("email_chr", "")
                // console.log("user_id_ids", localStorage.getItem('user_id'))



                dispatch(
                    resendCode(
                        formData, (res) => {
                            setResponceMsg(res.data.message);
                            setToasterType("success")
                            setHandleToaster(true)

                            setVerifyUserLoading(false);
                            setCheckAfterVerificationCodeSend(true);
                            setResendCodeCheck(true);
                            setResendCodeTimer(60);

                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }, (err) => {
                            setResponceMsg(err.data.message);
                            setToasterType("error")
                            setHandleToaster(true)

                            setVerifyUserLoading(false);

                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    )
                )
            }
        }
    }

    function handleValidateCode(e) {
        setIsCodeError(false);
        setRecievedCodeValue(e.target.value);
    }

    function handleGetUserById() {
        let details = {
            user_id_ids: localStorage.getItem('user_id_for_admin'),
            role_id_int: localStorage.getItem("roleId"),
            user_impersonate_flag: 0
        }

        dispatch(
            userById(details, (res) => {
                setApiResponse(false);
                // console.log(res, "user Data comes here")
                setAvatarArr(res.data.data.avatar_list)
                setInitialState(res)

            }, (err) => {
                setApiResponse(false);
            }),
        )

    }
    function hanldeActivateUser(e) {
        e?.preventDefault();
        setVerifyUserLoading(true);


        if (checkForEmailVerification) {
            if (recievedCodeValue !== "") {
                // console.log("activate user", recievedCodeValue)

                let formData = new FormData();
                formData.append("phone_code_id_int", 0);
                formData.append("phone_number_int", 0);
                formData.append("email_chr", emailNew);
                formData.append("otp_chr", recievedCodeValue);
                !isVerificationCodeSendDirectly && formData.append("user_id_ids", localStorage.getItem('user_id_for_admin'));

                // console.log("phone_code_id_int", 0)
                // console.log("phone_number_int", 0)
                // console.log("email_chr", emailNew)
                // console.log("otp_chr", recievedCodeValue)
                // console.log("user_id_ids", localStorage.getItem('user_id'))



                dispatch(
                    activateUser(formData, (res) => {

                        setResponceMsg(res.data.message);
                        setToasterType("success")
                        setHandleToaster(true)

                        setVerifyUserLoading(false);
                        handleCloseVerifyModal();
                        handleGetUserById()

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);

                    }, (err) => {
                        setIsCodeError(true);

                        setResponceMsg(err.data.message);
                        setToasterType("error")
                        setHandleToaster(true)

                        setVerifyUserLoading(false);

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
                )

            } else {
                setIsCodeError(true);
                setVerifyUserLoading(false);
            }
        }
        if (checkForPhoneVerification) {
            if (recievedCodeValue !== "") {
                // console.log("activate user", recievedCodeValue)

                let formData = new FormData();
                formData.append("phone_code_id_int", parseInt(countryCodeNewNew));
                formData.append("phone_number_int", parseInt(phoneNumberNew));
                formData.append("email_chr", "");
                formData.append("otp_chr", recievedCodeValue);
                !isVerificationCodeSendDirectly && formData.append("user_id_ids", localStorage.getItem('user_id_for_admin'));

                // console.log("phone_code_id_int", parseInt(countryCodeNewNew))
                // console.log("phone_number_int", parseInt(phoneNumberNew))
                // console.log("email_chr", "")
                // console.log("otp_chr", recievedCodeValue)
                // console.log("user_id_ids", localStorage.getItem('user_id'))


                dispatch(
                    activateUser(formData, (res) => {

                        setResponceMsg(res.data.message);
                        setToasterType("success")
                        setHandleToaster(true)

                        setVerifyUserLoading(false);
                        handleCloseVerifyModal();
                        handleGetUserById()

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);

                    }, (err) => {
                        setIsCodeError(true);

                        setResponceMsg(err.data.message);
                        setToasterType("error")
                        setHandleToaster(true)

                        setVerifyUserLoading(false);

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
                )
            } else {
                setIsCodeError(true);
                setVerifyUserLoading(false);
            }
        }
    }

    function handleOpenVerifyModal(data) {
        setTriggerForVerifyModal(true);
        if (data === "email") {
            setCheckForEmailVerification(true);
            setCheckForPhoneVerification(false);
        }
        if (data === "phone") {
            setCheckForPhoneVerification(true);
            setCheckForEmailVerification(false);

        }
    }

    function handleDirectlyResendCode(e, data) {
        if (data === "email") {
            setCheckForEmailVerification(true);
            setCheckForPhoneVerification(false);

            setEmailNew(email);
        }
        if (data === "phone") {
            setCheckForPhoneVerification(true);
            setCheckForEmailVerification(false);

            setCountryCodeNewNew(countryCode);
            setPhoneNumberNew(phonenumber);
        }

        setTriggerForVerifyModal(true);
        setCheckAfterVerificationCodeSend(true);
        setIsVerificationCodeSendDirectly(true);
    }

    useEffect(() => {
        if (checkAfterVerificationCodeSend && isVerificationCodeSendDirectly) {
            handleVerify();
        }
    }, [checkAfterVerificationCodeSend])


    function handleCloseVerifyModal() {
        setTriggerForVerifyModal(false);
        handleClearVerifyEmailPhoneStates();
    }




    // Verify Email and Phone ends here -------------------------

    // Tooltips here
    const tooltipDelete = (
        <Tooltip id="tooltip" >
            <strong >Delete Account</strong>
        </Tooltip>
    );

    // International phone number formator 
    useEffect(() => {
        if (phonenumber == null || phonenumber == "") {
            setPhoneNumberFormat(null)
        } else {
            setPhoneNumberFormat(InternationalPhoneFormatFun(`${countryCodeNew}`, `${phonenumber}`))
        }
    }, [phonenumber])

    // Set the role name of user
    const userRole = (str) => {
        const lowerCaseStr = str.toLowerCase();
        setRoleName(lowerCaseStr.charAt(0).toUpperCase() + lowerCaseStr.slice(1))
    }

    const setInitialState = (res) => {
        setFirstName(res.data.data.first_name_chr)
        setLastName(res.data.data.last_name_chr)
        setExtraNote(res?.data?.data?.extra_notes_chr ? res?.data?.data?.extra_notes_chr : "")
        setAddress(res.data.data.complete_address_chr)
        setCountryCode(res.data.data.phone_code_id_lng === null ? 0 : res.data.data.phone_code_id_lng)
        setPhonenumber(res.data.data.phone_number_int === null ? 0 : res.data.data.phone_number_int)
        setEmail(res.data.data.email_chr)
        setUserName(res.data.data.user_name_chr)
        setAvatarUrl(res.data.data.preferred_profile_picture_url)
        setAvatarId(res.data.data.avatar_id_lng)
        setAddressLine1(res.data.data.address.address_line_1_chr)
        setAddressLine2(res.data.data.address.address_line_1_chr)
        setZipCode(res.data.data.address.zip_code_int)
        setStateName(res.data.data.address.state_name_chr)
        setCityName(res.data.data.address.city_name_chr)
        setCountryName(res.data.data.address.country_name_chr)
        setLatVal(res.data.data.address.latitude_float)
        setLongVal(res.data.data.address.longitute_float)
        setRoleValue(res.data.data.role_id_int);
        setCountryCodeNew(res.data.data.country_phone_code_chr)
        setAddress(res.data.data.complete_address_chr)
        setPlaceId(res.data.data.address.place_id_chr)
        userRole(res.data.data.role_name_chr)
        setCompanyId(res.data.data.company_id_lng)
        setCompanyName(res.data.data.company_name_chr)

        setIsEmailConfirmed(res.data.data.email_confirmed_ysn)
        setIsPhoneConfirmed(res.data.data.phone_number_confirmed_ysn)
        setRoleIhhave(res.data.data.role_list)
    }

    useEffect(() => {
        onLoad();
    }, [])
    useEffect(() => {
        console.log(roleIHave)
    }, [roleIHave])

    const onLoad = () => {
        handleGetUserById()

        if (permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) {
            // let data = {}
            // dispatch(getRegistereedCompaniesApi(data, (res) => {
            //     setCompaniesList(res.data.data)

            // }, (err) => { }))

            const getComapnies = new FormData();
            getComapnies.append("user_id_ids", localStorage.getItem("user_id"));
            getComapnies.append("pagination_flag", 1);
            getComapnies.append("page_index", page);
            getComapnies.append("page_size", pageSize);
            getComapnies.append("sorting_order", sortByValue);
            getComapnies.append("sorting_column_name", columnName);
            getComapnies.append("search_area", searchValue);
            dispatch(
                apiGetRegisteredCompanies(getComapnies, (res) => {
                    // setElements(res.data.data);
                    setCompaniesList(res.data.data)
                }, (err) => { })
            );
        }
    }

    // const resp = () => {
    //     alert("res")
    //     return <ResponceToaster toasterType={'success'} message={'responceMsg'}/>
    // }

    function updateProfile(e) {
        e.preventDefault();


        if (firstNameValidation(firstName)) {

            setUpdateProfileLoading(true);
            setApiResponse(true)
            //   setLoaderActive(true)
            //   setUpdateProfileLoading(true);


            const profileData = new FormData()

            profileData.append("user_id_ids", localStorage.getItem('user_id_for_admin'))
            profileData.append("first_name_chr", firstName || "")
            profileData.append("last_name_chr", lastName || "")
            profileData.append("extra_notes_chr", extraNote || "")
            profileData.append("phone_code_id_int", +countryCode || 0)
            profileData.append("phone_number_int", +phonenumber || 0);
            profileData.append("place_id_chr", placeIdVal || " ");
            profileData.append("address_line_1_chr", addressLine1 || " ")
            profileData.append("address_line_2_chr", addressLine2 || " ")
            { photoToUpload != null ? profileData.append("default_image_flag", 1) : (profileData.append("default_image_flag", 0)) }
            profileData.append("city_name_chr", cityName || "")
            profileData.append("state_name_chr", stateName || "")
            profileData.append("country_name_chr", countryName || "")
            profileData.append("zip_code_int", zipCode || 0)
            profileData.append("longitute_float", longVal || 0.0)
            profileData.append("latitude_float", latVal || 0.0)
            profileData.append("complete_address_chr", address ? address : "")
            profileData.append("avatar_id_int", avatarId)
            profileData.append("role_id_ids", roleValue);
            profileData.append("company_id_ids", companyId ? companyId : 0)
            { photoToUpload != null && profileData.append("profile_picture", photoToUpload, "profilePhoto.png") }
            roleIHave.map((res) => {
                profileData.append("role_id_list", res)
            })


            dispatch(
                updateUserApi(
                    profileData,
                    (res) => {
                        setResponceMsg(res.data.message)
                        setToasterType("success")

                        setUpdateProfileLoading(false);
                        setApiResponse(false)

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);

                        handleGetUserById()

                        // resp()
                    },
                    (res) => {
                        setResponceMsg(res.data.message)
                        setToasterType("error")
                        setUpdateProfileLoading(false);
                        setApiResponse(false)

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    },
                ),
            )

        } else {
            setIsFirstNameError(true)

        }
    }

    // Functions for handling the Bio form data 
    const handleFirstName = (e) => {
        setIsFirstNameError(false)
        setFirstName(e.target.value)
    }
    const handleLastName = (e) => {
        setLastName(e.target.value)
    }

    const handleExtraNote = (e) => {
        setExtraNote(e.target.value)
    }

    const profileImgRef = useRef();

    const handleClickProfileImg = () => {
        profileImgRef.current.click();
    }

    function handlePhotoSelected(e) {
        setPhotoToUpload(e.target.files[0])
        // console.log(e.target.files[0])
    }

    // Function to delete Account permently 
    function deleteAccount() {
        let details = {
            user_id_ids: localStorage.getItem("user_id_for_admin"),
        };
        dispatch(
            deleteUser(details, (res) => {
                setOpenDialog(false);
                // localStorage.removeItem("user_id");
                // localStorage.removeItem("refresh_token");
                // localStorage.removeItem("username_chr");
                // localStorage.removeItem("name");
                // localStorage.removeItem("access_token");
                // localStorage.removeItem("fcm_token");
                // dispatch(signout());
                navigate("/admin");
            })
        );
    };

    function hanldeChangeAddress(e) {
        setSearchText(e.target.value)
    }

    useEffect(() => {
        const timeOutId = setTimeout(searchCalling, 1000);
        return () => clearTimeout(timeOutId);
    }, [searchText]);

    function searchCalling() {
        if (searchText.trim().length > 2) {

            let details = {
                address_chr: searchText.trim(),
            };
            dispatch(
                searchAddress(details, (res) => { setAddressArr(res.data.data) })
            );
        }
    }


    const popover = (
        <Popover id="popover-basic" className='custom-popover' style={{ minWidth: '308px', }}>

            <Popover.Body style={{ padding: '5px', boxShadow: '0px 0px 15px 0px rgba(0, 0, 0, 0.2)', }} >
                <div className='d-flex ' style={{}}>

                    {avatarArr.map((ele) =>
                    (
                        <>
                            <span style={{ cursor: 'pointer', margin: '1px' }}>
                                <Avatar src={ele.avatar_url_chr} size="35" alt=""
                                    onClick={() => {
                                        setPhotoToUpload(null)
                                        setAvatarUrl(ele.avatar_url_chr)
                                        setAvatarId(ele.avatar_id_ids)
                                        setUpdateBtn(true)
                                    }} />
                            </span>

                        </>
                    ))}
                    <div style={{ cursor: 'pointer', margin: '1px', backgroundColor: 'white', }}>
                        <Button onClick={handleClickProfileImg} className='custom-profile-btn' variant='outline-primary'>
                            <i className="bi bi-plus"></i>
                        </Button>
                        <input ref={profileImgRef} onChange={handlePhotoSelected} type="file" accept="image/*" hidden />
                    </div>

                </div>

            </Popover.Body>
        </Popover>
    );


    const backToAdminDashboard = () => {
        navigate("/admin")
    }

    const [roleValue, setRoleValue] = useState(2);
    function handleRoleValue(e) {
        setRoleValue(e.target.value)
    }

    function handleCompaniesSelectValue(e) {
        setCompanyId(e.target.value)
    }
    function handleEmail(e) {

        setEmail(e.target.value)
    }

    function handleGiveMoreRole(e) {
        console.log(roleIHave)
        if (roleIHave.includes(e)) {
            roleIHave.map((ele, index) => {
                if (ele === e) {
                    roleIHave.splice(index, 1)
                    setRoleIhhave([...roleIHave])
                }
            })
        } else {
            setRoleIhhave([...roleIHave, e])
        }


    }
    return (
        <>
            <div>
                <Card style={{ marginBottom: '10px', height: 'auto', background: 'white' }}>
                    <Card.Header>
                        <Card.Title>
                            <h4 onClick={backToAdminDashboard} className='back-to-admin-btn'>
                                <i style={{ marginRight: '10px', }} className="bi bi-arrow-left "></i>
                                {txtUserDetails}
                            </h4>
                        </Card.Title>
                    </Card.Header>
                    <div className='bio-header-section' style={{ border: 'none', paddingBottom: '0px' }}>
                        {/* <p className='bio-header'> {btnBio} </p> */}
                        <div className='d-flex align-items-center profile-image-group' >



                            <div className='d-flex align-items-center' >
                                <OverlayTrigger trigger='click' placement="bottom" overlay={popover} rootClose={true} >
                                    <div className='image-group' >
                                        {/* <Avatar src={profileAv} size="60" alt="" /> */}
                                        <Avatar src={photoToUpload != null ? URL.createObjectURL(photoToUpload) : avatarUrl} size="55" alt="" />
                                        <img className='edit-profile-icon' src={filter} alt="" />
                                    </div>
                                </OverlayTrigger>

                                <div className='d-flex user-name-section'>
                                    <span className='profile-user-name'>{userName}</span>
                                    <span className='profile-user-role'>{roleName}</span>
                                </div>
                            </div>



                            <OverlayTrigger placement="top" overlay={tooltipDelete}>
                                <span onClick={() => setBasicModalDeleteAccount(true)} className="d-flex align-items-center justify-content-center profle-trash-icon" >
                                    <i className="bi bi-trash "></i>
                                </span>
                            </OverlayTrigger>
                        </div>
                    </div>


                    <Card.Body>
                        <div >
                            <div className='d-flex profile-main-content'>
                                {/* <p className='main-info'>{txtMainInfo}</p> */}

                                <form onSubmit={(e) => updateProfile(e)}>

                                    {permissionArray.includes("CHANGE USER ROLE") && <JoinAsField labelName={txtRole} onChange={handleRoleValue} defaultValue={roleValue} />}
                                    {roleValue != 2 && role === 3 && <SelectStateCompanies labelName={"Company contact"} options={companiesList} onChange={handleCompaniesSelectValue} defaultValue={companyId} />}
                                    {roleValue != 2 && role === 4 && <InputField
                                        labelName={"Comapany contact"}
                                        placeholderName={"Company conatct"}


                                        value={companyName}
                                    />}

                                    <div className='combine-input-fileds' >
                                        <div className='comapany-address' style={{ width: '49%' }}>
                                            <InputField
                                                labelName={lblFirstName}
                                                placeholderName={lblFirstName}
                                                onChange={handleFirstName}
                                                errorOccured={isFirstNameError}
                                                errorMeesage={validFirstName}
                                                value={firstName}
                                                isRequired={true}
                                            />
                                        </div>

                                        <div className='comapany-address' style={{ width: '49%' }}>
                                            <InputField
                                                labelName={lblLastName}
                                                placeholderName={lblLastName}
                                                onChange={handleLastName}
                                                isError={false}
                                                errorText={validLastName}
                                                value={lastName}
                                            />
                                        </div>
                                    </div>


                                    <div className='combine-input-fileds' >
                                        <div className='comapany-address' style={{ width: '49%' }}>
                                            <UpdateEmailPhoneInputField
                                                labelName={lblEmail}
                                                value={email}
                                                isVerified={isEmailConfirmed}
                                                onClick={() => { handleOpenVerifyModal("email"); setCheckForEmailVerification(true); }}
                                                handleDirectlyResendCode={(e) => { handleDirectlyResendCode(e, "email"); setCheckForEmailVerification(true); }}
                                            />
                                        </div>

                                        <div className='comapany-address' style={{ width: '49%' }}>
                                            <UpdateEmailPhoneInputField
                                                labelName={txtMobileNumber}
                                                value={phoneNumberFormat != null ? phoneNumberFormat : 'NA'}
                                                isVerified={isPhoneConfirmed}
                                                onClick={() => { handleOpenVerifyModal("phone"); setCheckForPhoneVerification(true); }}
                                                handleDirectlyResendCode={(e) => { handleDirectlyResendCode(e, "phone"); setCheckForPhoneVerification(true); }}
                                            />
                                        </div>
                                    </div>

                                    {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
                                        <div className='row'>
                                            <div className='col-12'>
                                                <InputField
                                                    labelName={'Extra note'}
                                                    onChange={handleExtraNote}
                                                    isError={false}
                                                    errorText={''}
                                                    value={extraNote}
                                                    onBlur={() => { }}
                                                />
                                            </div>
                                        </div>
                                    }

                                    {/* <div className='combine-input-fileds' >
                                    <div className='comapany-address' style={{ width: '49%' }}>
                                        <InputField
                                            labelName={lblEmail}
                                            placeholderName={lblEmail}
                                            type={"email"}
                                            disabled={true}
                                            value={email}
                                            onChange={handleEmail}
                                        />
                                    </div>

                                    <div className='comapany-address' style={{ width: '49%' }}>
                                        <InputField
                                            labelName={lblPhoneNumber}
                                            placeholderName={lblPhoneNumber}
                                            value={phoneNumberFormat != null ? phoneNumberFormat : 'NA'}
                                            disabled={true}
                                        />
                                    </div>
                                </div> */}


                                    <label className="mb-1"><strong>{"Address"}</strong></label>
                                    <Select


                                        isSearchable
                                        name="color"
                                        placeholder={address ? address : txtSearchAddress}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                borderColor: 'rgba(107, 107, 107, 0.12)',
                                                borderWidth: 2,
                                                borderRadius: '7px',
                                                padding: '2px 0px !important',
                                                marginBottom: '10px',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: 'rgba(107, 107, 107, 0.12)',
                                                },
                                            })
                                        }}
                                        options={addressArr}
                                        getOptionLabel={(option) => option.description}
                                        getOptionValue={(option) => option.description}
                                        onInputChange={setSearchText}
                                        onChange={option => {
                                            setPlaceId(option.place_id)
                                            let details = {
                                                place_id: option.place_id
                                            }
                                            dispatch(addressByPlaceId(details, (res) => {
                                                setUpdateBtn(true)
                                                setSearchText('')
                                                setStateName(res.data.data.complete_address.state_name_chr)
                                                setZipCode(res.data.data.complete_address.zip_code_int)
                                                setCityName(res.data.data.complete_address.city_name_chr)
                                                setCountryName(res.data.data.complete_address.country_name_chr)
                                                setLongVal(res.data.data.location.lng)
                                                setLatVal(res.data.data.location.lat)
                                                setAddress(res.data.data.formatted_address)
                                                setAddressLine1(res.data.data.complete_address.address_line_1_chr)
                                                setAddressLine2(res.data.data.complete_address.address_line_2_chr)
                                            }))
                                        }}
                                    />
                                    <div className="mb-5">
                                        <label className="mb-1">
                                            <strong>{"Assinged Role"} </strong>
                                        </label>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                                            {rolesUserCanAssign?.map(({ role_id_ids, role_name_chr }, index) => (


                                                <div style={{ marginTop: '10px' }} >   <input
                                                    type="checkbox"
                                                    checked={roleIHave.includes(role_id_ids)}
                                                    className="form-check-input"
                                                    id="customCheckBox4"
                                                    onChange={(e) => {
                                                        handleGiveMoreRole(role_id_ids)

                                                    }}


                                                />
                                                    <span>  {role_name_chr}</span></div>





                                            ))}



                                        </div>
                                    </div>

                                    <div className='d-flex align-items-center justify-content-end'>
                                        <PrimaryButton
                                            style={{ width: '186px', background: 'green', border: 'none' }}
                                            onClick={(e) => updateProfile(e)}
                                            buttonName={btnUpdateProfile}
                                            type={"submit"}
                                            loadingMessage={btnUpdateProfileLoading}
                                            isLoading={updateProfileLoading}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>

                    </Card.Body>
                </Card>

                {/* {roleValue != 2 && <WorkInfo adminTrigger={true} />}

                {roleValue != 2 && <UploadDocuments adminTrigger={true} />} */}

            </div>

            {/* <!-- Modal --> */}
            <Modal className="fade" show={basicModalDeleteAccount} style={{}}>
                <div className='d-flex align-items-center justify-content-center' style={{ padding: '30px', flexDirection: 'column' }}>
                    <div style={{
                        fontSize: '24px',
                        fontWeight: '600',
                        textAlign: 'center',
                        padding: '20px',
                    }}>
                        Are you sure you want to delete this account ?
                    </div>

                    <div>

                        <WhiteGreenButton
                            buttonName={'No'}
                            onClick={() => setBasicModalDeleteAccount(false)}
                            variant={'primary'}
                            className={'white-background-btn'}
                        />

                        <WhiteGreenButton
                            buttonName={'Yes'}
                            onClick={deleteAccount}
                            className={'green-background-btn'}
                            variant={'primary'}
                        />
                    </div>

                </div>


            </Modal>

            {/* Modal for the  verify phone or email */}
            <Modal className="fade" show={triggerForVerifyModal} style={{}}>
                <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title>
                        {checkForEmailVerification && <>{"Update Email"}</>}
                        {checkForPhoneVerification && <>{"Update Mobile Number"}</>}


                    </Modal.Title>
                    <Button
                        variant=""
                        className="btn-close btn-close-service"
                        onClick={() => handleCloseVerifyModal()}
                    />

                </Modal.Header>

                <Modal.Body>
                    <div>
                        <div>
                            <div className='d-flex' style={{ fontSize: '15px', fontWeight: '500', marginBottom: '20px', color: 'black' }}>
                                {checkForEmailVerification &&
                                    <span className='text-center w-100'>
                                        {!checkAfterVerificationCodeSend ?
                                            <>{"Enter a new email and we will send an OTP for verification"}</> :
                                            <>{`Verification code has been send to your email ${emailNew}`}</>
                                        }
                                    </span>
                                }
                                {checkForPhoneVerification &&
                                    <span className='text-center w-100'>
                                        {!checkAfterVerificationCodeSend ?
                                            <>{"Enter new mobile number and we will send an OTP for verification"}</> :
                                            <>{`Verification code has been send to your mobile number ${phoneNumberNew}`}</>
                                        }

                                    </span>
                                }
                            </div>

                            <div>
                                <div>
                                    <form onSubmit={(e) => handleVerify(e)}>

                                        {checkForEmailVerification && !checkAfterVerificationCodeSend &&
                                            <InputField
                                                labelName={lblEmail}
                                                placeholderName={"Email"}
                                                type={"email"}
                                                value={emailNew}
                                                onChange={handleEmailNew}
                                                onBlur={handleEmailBlurCheckNew}
                                                errorMeesage={errorEmailMsg}
                                                errorOccured={isEmailErrorNew}
                                            />
                                        }

                                        {checkForPhoneVerification && !checkAfterVerificationCodeSend &&
                                            // <PhonenumberField
                                            //     inputValue={phoneNumberNew}
                                            //     handleInputValue={handlePhonenumberNew}
                                            //     errorOccured={isPhoneErrorNew}
                                            //     errorMeesage={validMobileNumberText}
                                            //     handleChangeCode={handleCountryCodeNew}
                                            //     handleOnBlur={handlePhonenumberBlurCheckNew}
                                            // />

                                            <EmailPhoneCombine
                                                inputValue={phoneNumberNew}
                                                handleInputValue={handlePhonenumberNew}
                                                errorOccured={isPhoneErrorNew}
                                                errorMessage={validMobileNumberText}
                                                handleChangeCode={handleCountryCodeNew}
                                                handleOnBlur={handlePhonenumberBlurCheckNew}
                                                isEnteringNumber={true}
                                                defaultCodeValue={countryCodeNewNew}
                                                label={txtMobileNumber}
                                            />
                                        }

                                        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                                            {!checkAfterVerificationCodeSend &&
                                                <PrimaryButton
                                                    onClick={handleVerify}
                                                    buttonName={btnVerify}
                                                    type={"submit"}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={verifyUserLoading}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    }}
                                                />
                                            }
                                        </div>

                                    </form>
                                </div>


                                <div>
                                    <form onSubmit={(e) => hanldeActivateUser(e)}>

                                        {checkAfterVerificationCodeSend &&
                                            <InputField
                                                labelName={"Code"}
                                                onChange={handleValidateCode}
                                                value={recievedCodeValue}
                                                errorOccured={isCodeError}
                                                errorMeesage={"enter valid security code"}
                                            />
                                        }

                                        {checkAfterVerificationCodeSend &&
                                            <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                                {resendCodeTimer != 0 && <span>Resend in 00:{resendCodeTimer > 9 ? resendCodeTimer : '0' + resendCodeTimer} </span>}
                                                <p style={{ marginBottom: '0px', fontSize: '15px' }}>Didn't receive the code?{" "}
                                                    <span onClick={handleVerify} style={{ color: 'orange', fontWeight: '700', pointerEvents: resendCodeCheck ? 'none' : 'auto', opacity: resendCodeCheck ? '0.5' : '1', cursor: 'pointer' }}>Resend now</span>
                                                </p>
                                            </div>
                                        }
                                        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>

                                            {checkAfterVerificationCodeSend &&
                                                <PrimaryButton
                                                    onClick={hanldeActivateUser}
                                                    buttonName={btnSubmit}
                                                    type={"submit"}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={verifyUserLoading}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    }}
                                                />
                                            }


                                        </div>

                                    </form>
                                </div>

                            </div>



                        </div>

                    </div>

                </Modal.Body>


            </Modal>



            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
            {/* {apiResponce && <ResponceForAPI show={apiResponce} />} */}
        </>
    )
}

export default ParticularUserDetailsForAdminPage;